import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[deCollapseExpandCard]',
  standalone: false
})
export class CollapseExpandCardDirective implements AfterViewInit {

  header: HTMLElement;
  body: HTMLElement;
  icon: HTMLElement;

  constructor(private el: ElementRef,
    private renderer: Renderer2) {
  }
  ngAfterViewInit(): void {
    this.header = this.el.nativeElement.querySelector('#deCollapseExpandCardHeader');
    this.body = this.el.nativeElement.querySelector('#deCollapseExpandCardBody');

    // event listen
    this.header.addEventListener('click', () => {
      this.onHeaderClick();
    });

    // add icon and style
    this.renderer.setStyle(this.header, 'cursor', 'pointer');
    this.renderer.setStyle(this.header, 'position', 'relative');
    this.addIcon('fa-angle-down');
  }

  addIcon(className: string) {
    this.icon = this.renderer.createElement('i');
    this.renderer.setStyle(this.icon, 'color', '#53627b')
    this.renderer.setStyle(this.icon, 'font-size', '20px')
    this.renderer.addClass(this.icon, 'fa');
    this.renderer.addClass(this.icon, 'float-right');
    this.renderer.addClass(this.icon, className);
    this.renderer.appendChild(this.header, this.icon);
  }

  removeIcon() {
    let toBeRemoveIcon;

    let elements = this.header.getElementsByTagName('svg');
    if (elements.length > 0) {
      toBeRemoveIcon = elements[0];
    } else {
      toBeRemoveIcon = this.header.getElementsByTagName('i')[0];
    }


    this.renderer.removeChild(this.header, toBeRemoveIcon);
    this.icon = null;
  }

  onHeaderClick() {
    this.removeIcon();
    if (this.body.style.display == 'none') {
      this.renderer.setStyle(this.body, 'display', 'unset');
      this.addIcon('fa-angle-down');
    } else {
      this.renderer.setStyle(this.body, 'display', 'none');

      this.addIcon('fa-angle-up');
    }
  }
}
